import {conf} from './conf';
import {reusable} from './convincely';
import {createStorage} from './storage';

export const input = reusable('input', createStorage(conf.storageKey));
export {input as coreInput};
